<template>
  <form class="flex flex-col space-y-4" @submit="onSubmit">
    <p class="text-sm text-gray-600">{{ t('pairDeviceDescription') }}</p>
    <InputField
      name="code"
      :label="t('pairingCode')"
      type="text"
      inputmode="numeric"
      autocomplete="one-time-code"
      maxlength="6"
      height="h-10"
    />
    <StatusBanner v-if="pairingError" variant="problem" :show-icon="false">
      {{ pairingError }}
    </StatusBanner>
    <CVButton type="submit" :is-loading="isLoading" variant="default" class="w-full">
      {{ t('pairDeviceSubmit') }}
    </CVButton>
    <CVButton variant="link" type="button" class="w-full" @click="emit('onSwitchToLogin')">
      {{ t('back') }}
    </CVButton>
  </form>
</template>

<script setup lang="ts">
import InputField from '@/components/InputField.vue';
import StatusBanner from '@/components/StatusBanner.vue';
import CVButton from '@/components/buttons/CVButton.vue';
import { useI18n } from 'vue-i18n';
import { devicePairingSchema } from '@/validation/device-pairing.schema';
import { useForm } from 'vee-validate';

const { t } = useI18n();

defineProps<{
  isLoading: boolean;
  pairingError?: string;
}>();

const emit = defineEmits<{
  (e: 'onPairDeviceSubmit', value: { code: string }): void;
  (e: 'onSwitchToLogin'): void;
}>();

const { handleSubmit: handleSubmitPairing } = useForm<{ code: string }>({
  validationSchema: devicePairingSchema,
});

const onSubmit = handleSubmitPairing(async (values) => {
  emit('onPairDeviceSubmit', { code: values.code.trim() });
});
</script>

<i18n lang="json">
{
  "en": {
    "pairDeviceDescription": "Enter the 6-digit code shown in ROS settings after connecting a device.",
    "pairingCode": "Pairing code",
    "pairDeviceSubmit": "Sign in on this device",
    "back": "Back to login"
  },
  "de": {
    "pairDeviceDescription": "Geben Sie den 6-stelligen Code ein, der in den ROS-Einstellungen nach „Gerät verbinden“ angezeigt wird.",
    "pairingCode": "Kopplungscode",
    "pairDeviceSubmit": "Auf diesem Gerät anmelden",
    "back": "Zurück zur Anmeldung"
  }
}
</i18n>
